import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@mui/material";
import Langs from "../../../app/lang/langs";
import EvaluationRatioButton from "./EvaluationRatioButton";

function MonthCell({ rowData, monthNumber, year, onClickCell }) {
    if (!rowData?.data) return null;
    const month = rowData.data[monthNumber.toString()];
    const yesCount = month['yes'] || 0;
    const noCount = month['no'] || 0;
    return (
        <EvaluationRatioButton
            yesCount={yesCount}
            noCount={noCount}
            month={monthNumber}
            year={year}
            rowData={rowData}
            onClickCell={onClickCell}
            entreeDate={rowData.entree_date}
            sortieDate={rowData.sortie_date}
            idTeam={rowData.id_team}
        />
    );
}

export default function EvaluationsTable({ scrollHeight, groupedData, monthColumns, visibleTeams, expandedTeamId, onToggleGroup, year, onClickCell }) {
    return (
        <TableContainer sx={{ maxHeight: scrollHeight, overflow: 'auto' }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell><Langs str="Matricule" /></TableCell>
                        <TableCell><Langs str="Family Name" /></TableCell>
                        <TableCell><Langs str="Name" /></TableCell>
                        {monthColumns.map(({ key, header }) => (
                            <TableCell key={key} align="center">{header}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {groupedData.map((group) => {
                        const isExpanded = expandedTeamId === group.id_team || visibleTeams.length === 1;
                        return (
                            <React.Fragment key={group.id_team}>
                                <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                                    <TableCell colSpan={3 + monthColumns.length}>
                                        {visibleTeams.length > 1 && (
                                            <IconButton size="small" onClick={() => onToggleGroup(group.id_team)}>
                                                {isExpanded ? '\u25BC' : '\u25B6'}
                                            </IconButton>
                                        )}
                                        <strong>{group.team_name}</strong>
                                    </TableCell>
                                </TableRow>
                                {isExpanded && group.rows.map((row, i) => (
                                    <TableRow key={row.id_collab} sx={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <TableCell>{row.matricule}</TableCell>
                                        <TableCell>{row.nom}</TableCell>
                                        <TableCell>{row.prenom}</TableCell>
                                        {monthColumns.map(({ key }) => (
                                            <TableCell key={key} align="center" sx={{ p: 0.5 }}>
                                                <MonthCell
                                                    rowData={row}
                                                    monthNumber={key}
                                                    year={year}
                                                    onClickCell={onClickCell}
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                                {isExpanded && (
                                    <TableRow>
                                        <TableCell colSpan={3 + monthColumns.length}>
                                            <strong><Langs str="Total" /> : {group.rows.length}</strong>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
